<div class="map-container">
  <google-map #map height="103%" width="100%" 
    (mapInitialized)="onMapReady(map)" 
    (mapClick)="setLocation($event)"
    [options]="options"
  >
    <map-indication-card />
    <map-polylines />
    <map-markers />
    <map-proyected-point />
  </google-map>

  <map-step-navigation />
  <app-make-payment-button />

    @if(showDevPanel()){
      <dev-panel-map />
    } 
  
</div>

<!-- MAP OPTIONS
    (mapInitialized)="onMapReady()" 
    (mapDragstart)="disableAutoCenter()"
    (zoomChanged)="disableAutoCenter()"
-->
